import { render } from "./resetFormView.vue?vue&type=template&id=7c607b4e"
import script from "./resetFormView.vue?vue&type=script&lang=js"
export * from "./resetFormView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__